import React, { forwardRef, type Ref } from 'react';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { useIntl } from '@atlassian/jira-intl';
import { CommonNavMenuButton } from '../../../common/ui/common-nav-menu-button/main.tsx';
import messages from './messages.tsx';
import type { MoreNavMenuButtonTriggerProps } from './types.tsx';

export const MoreNavMenuButtonTrigger = forwardRef(
	// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
	({ name, ...props }: MoreNavMenuButtonTriggerProps, ref: Ref<HTMLButtonElement>) => {
		const { formatMessage } = useIntl();

		return (
			<CommonNavMenuButton
				{...props}
				icon={(iconProps) => <ShowMoreHorizontalIcon {...iconProps} size="small" />}
				label={
					name
						? formatMessage(messages.moreActionsFor, { name })
						: formatMessage(messages.moreActions)
				}
				ref={ref}
				isTooltipDisabled={false}
				tooltip={{
					content: formatMessage(messages.moreActions),
					hideTooltipOnClick: true,
				}}
				interactionName="nav4-sidebar-more-actions-button"
			/>
		);
	},
);
